import React, {FunctionComponent, useState, useEffect} from 'react'
import {IProps} from './IProps'
import Header from './Header/Header'
import Body from './Body/Body'
import style from './style.scss'
import Spinner from '../../../App/Components/Spinner/Spinner'
import Button from '../../../App/Components/Button/Button'

const ReportTable: FunctionComponent<IProps> = ({results, span}) => {
    const [resultIndex, setResultIndex] = useState<number>(0)

    useEffect(
        () => {
            if (results.length < resultIndex + 1) {
                setResultIndex(0)
            }
        },
        [results]
    )

    if (! results[resultIndex]) {
        return <Spinner/>
    }

    const getCompareButtons = () => {
        if (results.length < 2) {
            return
        }

        return (

            <div className={style.buttonWrapper}>
                {
                    results.map((result, index) => {
                        return <Button
                            onClick={() => setResultIndex(index)}
                            color={index === 1 ? '#FFA500' : '#005cdb'}
                            buttonStyle={index === resultIndex ? undefined : 'dim'}
                            key={`compareButton${index}`}
                        >
                            Range {index + 1}
                        </Button>
                    })
                }
            </div>
        )
    }

    return (
        <>
            {getCompareButtons()}
            <table className={'table'}>
                <Header result={results[resultIndex]} span={span}/>
                <Body result={results[resultIndex]} span={span}/>
            </table>
        </>
    )
}

export default ReportTable
